/**
 * Channel-agnostic one-time-code input. Knows nothing about phone vs. email.
 *
 * autoComplete="one-time-code" is what lets iOS and Android offer the code
 * straight from the SMS — without it the user has to switch apps and retype.
 */
const OtpInput = ({ value, onChange, disabled = false, autoFocus = false, length = 6 }) => (
  <input
    type="text"
    inputMode="numeric"
    autoComplete="one-time-code"
    autoFocus={autoFocus}
    disabled={disabled}
    maxLength={length}
    value={value}
    onChange={event => onChange(event.target.value.replace(/\D/g, "").slice(0, length))}
    className="mb-4 w-full rounded-md border-0 bg-neutral-100 p-4 text-center font-mono text-2xl tracking-[0.5em] disabled:opacity-50"
    placeholder="------"
    aria-label={`${length}-digit verification code`}
  />
)

export default OtpInput
